import Cookies from "js-cookie"

const TokenKey = "X-DQ123-Authorization"

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token, { domain: 'dq123.com'})
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}
